import React, { useState, useEffect, useRef  } from 'react';
import { Grid, GridColumn as Column } from '@progress/kendo-react-grid';
import { filterBy } from "@progress/kendo-data-query";
import api from '../FetchComponents/FetchComponentsServices';
import { Loader } from "@progress/kendo-react-indicators";
import MoreDetailsWindow from './MoreDetailsWindow';
import { DateSelectFilterCell } from './DateSelectFilterCell'
import { CheckboxFilterCell } from './CheckboxFilterCell'
import helper from '../Shared/helper'

const options = ['One Hour Ago', '24 Hours Ago', 'One Week Ago', 'One Month Ago']
const currentDate = new Date()

const initialFilter = {
  logic: "and",
  filters: [
    {
      field: "createdDate",
      operator: "gte",
      value: new Date(currentDate.getTime() - 24 * 60 * 60 * 1000)
    },
    {
      field: "successCount",
      operator: "gte",
      value: 0
    },
    {
      field: "failedCount",
      operator: "gte",
      value: 0
    },
  ],
};

const CategoryFilterCell = (props) => (
  <DateSelectFilterCell
    {...props}
    data={options}
    defaultItem={'24 Hours Ago'}
  />
);

const SuccessFilterCell = (props) => (<CheckboxFilterCell {...props} label='Successes' />);
const FailuresFilterCell = (props) => (<CheckboxFilterCell {...props} label='Failures' />);

const ChangeLog = (isRunning) => {
  const [Loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [checked, setChecked] = useState(false);
  const [jobID, setJobID] = useState(0);
  const [filter, setFilter] = useState(initialFilter);
  const [showMoreDetails, setShowMoreDetails] = useState(false);
  const prevIsRunning = useRef(isRunning);

  const fetchData = async () => {
    const result = await api.GetJobSummaries();
    const data = result.map((data, index) => {
      const createdDate = new Date(data.createdDate)
      return {
        ...data,
        runtime: helper.getRuntime(createdDate, new Date(data.processedDate)),
        notes: getNotes(data, index),
        createdDate: createdDate
      }
  })
    setData(data);
    setLoading(false)
  };

  useEffect(() => {
    fetchData();
  }, []);
  
  useEffect(() => {
    if (prevIsRunning.current === true && isRunning.isRunning === false) {
      fetchData();
    }
    prevIsRunning.current = isRunning.isRunning
  }, [isRunning]);

  useEffect(() => {
    let newFilter = filter

    if (newFilter && newFilter.length) {
      if (checked) {
        setFilter(newFilter[1].value = 1)
      } else {
        setFilter(newFilter[1].value = 0)
      }
    }
  }, [checked]);
  
  const getNotes = (data, index) => {
    if(index < 3) {
      let notes = helper.checkIfJobIsRunning(data)
      return notes
    }
    return data.notes
  }

  const closeMoreDetails = () => {
    setShowMoreDetails(false)
  }

  const openMoreDetails = (dataItem) => {
    setJobID(dataItem.jobID)
    setShowMoreDetails(true)
  };

  const expandButton = (props) => {
    return (
      <td {...props.tdProps} >
        <button aria-label={`more details for ${props.dataItem.jobID}`} onClick={() => openMoreDetails(props.dataItem)}>+</button>
      </td>
    );
  };

  return (
    <>
      {showMoreDetails && jobID !== 0 && <MoreDetailsWindow jobID={jobID} closeWindow={closeMoreDetails} />}
      <h2>Job Summary Data</h2>
      {Loading
        ? <><Loader className='spinner-small' size="small" type={"infinite-spinner"} /><em> Loading...</em></>
        : <Grid fixedScroll={true} rowHeight={50} data={filterBy(data, filter)}
          style={{ height: window.innerHeight - 400 }}
          filterable={true} filter={filter} onFilterChange={(e) => setFilter(e.filter)}
        >
          <Column field="" width='60px' title="" filterable={false} cell={expandButton} />
          <Column field="createdDate" width='230px' title="Timestamp" filter="date" filterCell={CategoryFilterCell} format={"{0:G}"} />
          <Column field="runtime" width='90px' title="Runtime" filterable={false} className={'runtime-collumn'} />
          <Column field="jobID" width='100px' title="Id Number" filterable={false} />
          <Column field="successCount" width='100px' title="Successes" filter="numeric" filterCell={SuccessFilterCell} />
          <Column field="failedCount" width='100px' title="Failures" filter="numeric" filterCell={FailuresFilterCell} />
          <Column style={{ height: "50" }} field="notes" title="Notes" />
        </Grid>
      }
    </>
  );
};

export default ChangeLog;